





import { Component, Vue,Watch } from 'vue-property-decorator';
import ApplicationList from "@/components/applications/ApplicationList.vue";
import ShowApplications from "@/components/applications/ShowApplication.vue";

@Component({
    components:{
        ApplicationList,
        ShowApplications
    }
})
export default class Applications extends Vue {
    private applications = {};

    private applicationSid: string | null = null;

    @Watch('$route')
    routeChanged() {
        this.changeRoute();
    }

    changeRoute() {
        if (this.$route.params != null && this.$route.params.sid != null) {
            this.applicationSid = String(this.$route.params.sid);
        } else {
            this.applicationSid = null;
        }
        console.log(this.$route.params);
    }

    mounted() {
        this.changeRoute();
        //
    }
}
